import { companyService } from "../../services/company.service";
import { settingService } from "@/services/setting.service";
import { PinBoard } from "../../models/pinboard.model";
import { Setting } from "../../models/setting.model";
import { pinboardService } from "@/services/pinboard.service";

import Utils from "@/common/utils";
import Vue from "vue";

const vm: any = new Vue();

// tslint:disable
const state = {
    companyName: localStorage.getItem("companyName") || "",
    companyImage: localStorage.getItem("companyImage") || "",
    companyId: localStorage.getItem("companyId") || "",
    pinboards: JSON.parse(localStorage.getItem("pinboards") as string) || [] as PinBoard[],
    setting: JSON.parse(localStorage.getItem("setting") as string) || {} as Setting,
    currentPinBoard: JSON.parse(localStorage.getItem("currentPinBoard") as string) || 0 as number,
    loading:false,
    menu:false,
    errors:[] as string[]
};
const getters = {
    loading: (appState: any) => appState.loading,
    menu: (appState: any) => appState.menu,
    companyName: (appState: any) => appState.companyName,
    companyImage: (appState: any) => appState.companyImage,
    companyId: (appState: any) => appState.companyId,
    pinboards: (appState: any) => appState.pinboards,
    setting: (appState: any) => appState.setting,
    currentPinBoardName:(appState: any) => {
        let templist:PinBoard[] = appState.pinboards as PinBoard[];
        let pinBoard = templist.find(p => p.id === appState.currentPinBoard);
        if(pinBoard !== undefined) {
            return pinBoard.name;
        }
        else
            return ""
    },
    currentPinBoardId: (appState: any) => appState.currentPinBoard,
    currentPinBoard:(appState: any) => {
        let templist:PinBoard[] = appState.pinboards as PinBoard[];
        let pinBoard = templist.find(p => p.id === appState.currentPinBoard);
        if(pinBoard !== undefined) {
            return pinBoard;
        }
        else
            return ""
    },
    errors:(appState:any) => appState.errors
};
const actions = {
    setMenu: ({commit, dispatch}: {commit: any, dispatch: any} , val: boolean) => {
        commit("mSetMenu", val);
    },
    setLoading: ({commit, dispatch}: {commit: any, dispatch: any} , val: boolean) => {
        commit("setLoading", val);
    },
    getCompanyPinBoards: async ({commit, dispatch, getters}: {commit: any, dispatch: any, getters:any} , companyId: string) => {
        var result = await pinboardService.getAll(getters["companyId"]);
        if(result != null){
            commit("setPinboards", result);
        }
    },
    getCompanyInfoFromKey: async ({commit, dispatch}: {commit: any, dispatch: any} , id: string) => {
        commit("setCompanyId", id);
        return companyService.get(id).then((promise) => {
            pinboardService.getAll(promise.id).then((result) => {
                commit("setPinboards", result);
            });
            console.log(promise);
            commit("setCompanyName", promise.name);
            commit("setCompanyId", promise.id);
            if(promise.image){
                commit("setCompanyImage", promise.image);

            }
        });
    },
    clearCompanyInfo: async ({commit, dispatch}: {commit: any, dispatch: any}) => {
        commit("mClearCompanyInfo");
    },
    getSetting: ({commit, dispatch}: {commit: any, dispatch: any} , companyId: string) => {
        return settingService.getByCompanyId(companyId).then((promise) => {
            if(promise !== null) {
                commit("setSetting", promise);
            }
        });
    },
    setSetting: ({commit, dispatch}: {commit: any, dispatch: any}, setting: Setting) => {
        commit("setSetting", setting);
    },
    setCurrentPinBoard: ({commit, dispatch}: {commit: any, dispatch: any} , pinBoardId: number) => {
        commit("setCurrentPinBoard", pinBoardId);
    },
    addErrors: ({commit, dispatch}: {commit: any, dispatch: any} , messages: string[]) => {
        commit("mAddError", messages);
        vm.$notify({
            group: 'message',
            title: 'Något gick fel',
            text: messages,
            duration: 5000,
            type: 'error',
        });
    },
    resetErrors: ({commit, dispatch}: {commit: any, dispatch: any}) => {
        commit("mAddError", []);
    },
};

const mutations = {
    mSetMenu:(appState:any, val:boolean) =>{
        appState.menu = val;
    },
    setLoading:(appState:any, val:boolean) =>{
        appState.loading = val;
    },
    setCompanyName: (appState: any, name:string) => {
        appState.companyName = name;
        localStorage.setItem("companyName", name);
    },
    setCompanyImage: (appState: any, image:Uint8Array) => {
        appState.companyImage = image;
        localStorage.setItem("companyImage", image.toString());
    },
    setCompanyId: (appState: any, id:string) => {
        appState.companyId = id;
        localStorage.setItem("companyId", id);
    },
    mClearCompanyInfo: (appState: any) => {
        appState.companyId = "";
        appState.companyImage = "";
    },
    setPinboards: (appState: any, pinboards:PinBoard[]) => {
        appState.pinboards = pinboards;
        localStorage.setItem("pinboards", JSON.stringify(pinboards));
    },
    setSetting: (appState: any, setting:Setting) => {
        appState.setting = setting;
        localStorage.setItem("setting", JSON.stringify(setting));
    },
    setCurrentPinBoard: (appState: any, pinBoardId:number) => {
        localStorage.setItem("currentPinBoard", JSON.stringify(pinBoardId));
        appState.currentPinBoard = pinBoardId;
    },
    mAddError:(appState: any, messages:string[]) => {
        appState.errors = [];
        appState.errors = messages;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};